export default __webpack_public_path__ + "app/src/PageHeader/components/logo.png";